import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Invoice';

const routes = [
    {
        matchRegex: '/Invoice',
        name: getRouteName(MODULE_NAME, 'Listing'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-list', label: 'Invoice List' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_FETCH_LIST_SUCCESS',
                    label: 'Trigger Fetch List Successfully',
                },
            ],
        },
    },
    {
        matchRegex: '/Invoice/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail (Standard)'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-line-list', label: 'Invoice Line List' },
                { key: 'credit-line-list', label: 'Credit Line List' },
            ],
        },
    },
    {
        matchRegex: '/CGroupInvoice/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail (Customer Grouped)'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-line-list', label: 'Invoice Line List' },
            ],
        },
    },
    {
        matchRegex: '/PPMInvoice/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail (PPM)'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN,
        ],
        image: PreviewDetailImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_GET_COLUMN', label: 'Show data column in line invoice' },
            ],
        },
        parentKeys: {
            [SLOT_KEY.SLOT_V_TABLE_COLUMN]: [
                { key: 'invoice-line-list', label: 'Invoice Line List' },
            ],
        },
    },
]

export default routes;